import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { UserService } from '../../services/user.service';
import { GroupService } from '../../services/group.service';

@Component({
    selector: 'app-display-user',
    templateUrl: './display-user.component.html',
    styleUrls: ['./display-user.component.css', '../../app.component.css']
})

export class DisplayUserComponent implements OnInit {

    user: any = [];

    id: string;

    guSubs: any;
    ggSubs: any;

    groups = [];

    constructor(private router: Router,
                private activatedRoute: ActivatedRoute,
                private userService: UserService,
                private groupService: GroupService) {
            
            this.id = this.activatedRoute.snapshot.paramMap.get('id');

            this.ggSubs = this.groupService.getGroups().subscribe(tempGroups => {
                this.ggSubs.unsubscribe();

                const tGroup = [];

                for (let idxTg in tempGroups) {
                    tGroup[tempGroups[idxTg].id$] = tempGroups[idxTg].name;
                }

                this.guSubs = this.userService.getUser(this.id).subscribe((user) => {
                    this.guSubs.unsubscribe();

                    this.user = user;
                    for (let item in this.user.groups) {
                        this.groups.push({ groupName: tGroup[this.user.groups[item]] });
                    }
                });
            });
    }

    ngOnInit() {

    }

}
